module.exports = __webpack_public_path__ + "assets/img/kj_img1.1eb8dc9f.png";